import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class Content {
  index() {
    return Axios.get(API_URL + 'content-list');
  }

  show(content) {
    return Axios.get(API_URL + `content/${content}`);
  }
}

export default new Content();



// WEBPACK FOOTER //
// ./src/api/content.js